module.exports = __webpack_public_path__ + "assets/img/3629c0e85e9b255e80eceed780ef339d.png";